import { createSelector } from 'reselect'
import { selectCurrentMailboxId } from 'selectors/mailboxes/selectCurrentMailboxId'
import { selectTicketSearchResultsByQueryId } from 'selectors/search'
import { filterSearches } from 'util/search'

const makeSelectAgentTicketSearchesForCurrentMailbox = state => {
  return createSelector(
    selectTicketSearchResultsByQueryId,
    selectCurrentMailboxId,
    (searches, mailboxId) => {
      return filterSearches(searches, {
        all: mailboxId ? { state, mailbox: mailboxId } : { state },
        present: { assignee: true, '*': false },
      })
    }
  )
}
export const selectAgentTicketSearchesForOpenAndCurrentMailbox = makeSelectAgentTicketSearchesForCurrentMailbox(
  'opened'
)
export const selectAgentTicketSearchesForClosedAndCurrentMailbox = makeSelectAgentTicketSearchesForCurrentMailbox(
  'closed'
)
export const selectAgentTicketSearchesForSnoozedAndCurrentMailbox = makeSelectAgentTicketSearchesForCurrentMailbox(
  'snoozed'
)
